<template>
    <div class="stock-distribution-modal">
        <div v-if="showModal">
            <!-- <div class="mask"></div> -->
            <div class="stock-content clearfix">
                <!-- <div class="stock-title clearfix">
                    <Icon class="stock-title-icon pull-right" type="md-close" @click="showModal = false" />
                </div> -->
                <div class="title">
                    库存分配分为基本版和高级版，请联系客服了解并选择开通哪个版本。
                </div>
                <div class="item-container">
                    <div class="choose-item">
                        <div class="item-title">基础版</div>
                        <div class="item-desc">
                            适用多店铺运营，完全共享库存
                            <Poptip
                                placement="bottom"
                                content="所有店铺共享仓库库存，销售速度快的店铺不断“抢占”库存，符合市面上常见的销售策略。"
                            >
                                <Icon
                                    class="item-icon"
                                    type="ios-alert-outline"
                                />
                            </Poptip>
                        </div>
                    </div>
                    <div class="choose-item">
                        <div class="item-title">高级版</div>
                        <div class="item-desc">
                            适用于多店铺运营，相对共享库存
                            <Poptip
                                placement="bottom"
                                content="店铺可分为多个组，同一分组内的店铺才共享仓库库存。适合有特定销售策略的卖家。"
                            >
                                <Icon
                                    class="item-icon"
                                    type="ios-alert-outline"
                                />
                            </Poptip>
                        </div>
                    </div>
                </div>
                <div class="bottom pull-right">
                    <Checkbox @on-change="handleChange" v-model="isHideNext">不再显示</Checkbox>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Cookies from "js-cookie";
export default {
    data () {
        return {
            showModal: true,
            isHideNext: false
        }
    },
    methods: {
        handleChange (val) {
            console.log(val);
            if (val) {
                Cookies.set('StockLastUserId', {
                    userId: Cookies.get('userId'),
                    isHideNext: true
                });
            }
            else {
                Cookies.remove('StockLastUserId');
            }
        },
    }
};
</script>

<style lang="scss" scoped>
.stock-distribution-modal {
    // position: absolute;
    // left: 0;
    // top: 0;
    // right: 0;
    // bottom: 0;

    .mask {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.6);
        z-index: 999;
    }

    .stock-content {
        // position: absolute;
        // background-color: #f6f8f9;
        background-color: #fff;
        border-radius: 10px;
        margin: auto;
        // left: 0;
        // top: -100px;
        // right: 0;
        // bottom: 0;
        padding: 20px;
        // width: 800px;
        // height: 450px;
        // background-color: #f6f8f9;
        // padding: 50px;
        // min-height: 600px;
        // height: 100%;
        // background: #fff;
        z-index: 1000;

        .stock-title {
            padding: 10px 15px;
            margin-bottom: 10px;
            .stock-title-icon {
                font-size: 20px;
                cursor: pointer;
            }
        }

        .title {
            font-size: 18px;
            margin-bottom: 50px;
            text-align: center;
        }
    }
    .item-container {
        display: flex;
        justify-content: space-around;
        padding-bottom: 20px;

        .choose-item {
            $height: 200px;
            position: relative;
            width: 45%;
            border: 1px solid #e4e7ed;
            background-color: #fff;
            // background-color: #f6f8f9;
            
            height: $height;
            border-radius: 5px;

            .item-title {
                font-size: 22px;
                font-weight: bold;
                text-align: center;
                line-height: $height;
            }

            .item-desc {
                position: absolute;
                width: 100%;
                text-align: center;
                bottom: 10px;
                font-size: 14px;

                .item-icon {
                    margin-left: 5px;
                    cursor: pointer;
                }
            }
        }
    }
}
</style>